/**
 * PKCE en el navegador (RFC 7636, S256). El núcleo solo acepta `code_challenge_method=S256`
 * (`apps/idp/src/oidc/service.ts` `loadAuthorizeClient`), así que aquí no hay otro camino.
 *
 * Todo lo aleatorio y el hash salen de la Web Crypto API, que se recibe inyectada: así esto se
 * prueba con `node --test` sin navegador, y de paso queda claro que el paquete no depende de
 * ninguna variable global escondida.
 */
/**
 * Base64url sin relleno, que es la codificación que exige PKCE.
 *
 * Usa `btoa`, que es global tanto en el navegador como en Node desde la v16: no hace falta `Buffer`
 * ni una rama por entorno, y así el paquete se compila con `types: []` —sin los tipos de Node—,
 * que es lo que garantiza que nada de aquí dependa de una API que en el navegador no existe.
 */
export function base64UrlEncode(bytes) {
    let binary = "";
    for (const byte of bytes)
        binary += String.fromCharCode(byte);
    return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
/** Cadena aleatoria en base64url, para `code_verifier` y para `state`. */
export function randomUrlSafe(crypto, bytes = 32) {
    return base64UrlEncode(crypto.getRandomValues(new Uint8Array(bytes)));
}
/**
 * `code_verifier` de 43-128 caracteres, como pide el RFC. Con 48 bytes salen 64 caracteres: dentro
 * del rango y con margen de sobra sobre el mínimo de entropía.
 */
export function createCodeVerifier(crypto) {
    return randomUrlSafe(crypto, 48);
}
/** `code_challenge` = base64url(SHA-256(verifier)). */
export async function createCodeChallenge(crypto, verifier) {
    const data = new TextEncoder().encode(verifier);
    const digest = await crypto.subtle.digest("SHA-256", data);
    return base64UrlEncode(new Uint8Array(digest));
}
//# sourceMappingURL=pkce.js.map